import { EntityLayout, EntityOrphanWarning, EntitySwitch, isKind, isOrphan } from '@backstage/plugin-catalog';
import React from 'react';
import { SystemPage } from './catalog/system/SystemPage';
import { EntityTechdocsContent } from '@backstage/plugin-techdocs';
import { DefaultEntityPage } from './catalog/DefaultEntityPage';
import { GroupPage } from './catalog/group/GroupPage';
import { UserPage } from './catalog/user/UserPage';
import { ApiPage } from './catalog/api/ApiPage';

export const EntityPage = (
  <>
  <EntityLayout.Route path="/docs" title="Docs">
      <EntityTechdocsContent />
  </EntityLayout.Route>
  <EntitySwitch>
      <EntitySwitch.Case if={isKind('user')} children={<UserPage />} />
      <EntitySwitch.Case if={isKind('system')} children={<SystemPage />} />
      <EntitySwitch.Case if={isKind('group')} children={<GroupPage />} />
      <EntitySwitch.Case if={isKind('api')} children={<ApiPage />} />
      <EntitySwitch.Case if={isOrphan} children={<EntityOrphanWarning />} />
      <EntitySwitch.Case children={<DefaultEntityPage />} />
  </EntitySwitch>
</>
);
